module.exports = __webpack_public_path__ + "img/img-box-services-design-right.1d8d844d.png";